export default [
  {
    path: '/invoices/create',
    name: 'InvoiceCreate',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/InvoiceCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear factura'
    }
  },
  {
    path: '/invoices/:id',
    name: 'InvoiceRetrieve',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/InvoiceRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Factura'
    }
  },
  {
    path: '/invoices',
    name: 'InvoiceList',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/InvoiceList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturas'
    }
  },
  {
    path: '/invoices/:id/edit',
    name: 'InvoiceUpdate',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/InvoiceCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar factura'
    }
  },
  {
    path: '/bulks/invoices',
    name: 'InvoiceBulkListCreate',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/InvoiceBulkListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Procesos de facturación por lotes'
    }
  },
  {
    path: '/bulks/invoices/:id',
    name: 'InvoiceBulkRetrieve',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/InvoiceBulkRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Facturación por lotes'
    }
  },
  {
    path: '/credit-notes',
    name: 'CreditNoteList',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/CreditNoteList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Notas de crédito'
    }
  },
  {
    path: '/credit-notes/:id',
    name: 'CreditNoteRetrieve',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/CreditNoteRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Nota de crédito'
    }
  },
  {
    path: '/debit-notes/:id',
    name: 'DebitNoteRetrieve',
    component: () => import(/* webpackChunkName: "invoices" */ '@/views/invoice/DebitNoteRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Nota de débito'
    }
  }
]